import { useEffect, useRef } from "react";

const ScrollProgress = () => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(() => {
          const scrollTop = window.scrollY;
          const docHeight = document.documentElement.scrollHeight - window.innerHeight;
          const progress = docHeight > 0 ? scrollTop / docHeight : 0;
          el.style.transform = `scaleX(${progress})`;
          ticking = false;
        });
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      ref={ref}
      className="fixed top-0 left-0 right-0 h-[2px] z-[100] origin-left"
      style={{
        transform: "scaleX(0)",
        background: "linear-gradient(90deg, hsl(var(--primary)), hsl(var(--warmglow)), hsl(var(--violet-glow)))",
        willChange: "transform",
      }}
    />
  );
};

export default ScrollProgress;
